// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--a156b";
export var footer = "Footer-module--footer--61443";
export var hr = "Footer-module--hr--7edb8";
export var secondary = "Footer-module--secondary--10947";